export interface ArticleImpact {
  value: string;
  label: string;
  icon: string;
}

export interface Article {
  id: string;
  title: string;
  summary: string;
  image: string;
  entrepreneur: string;
  country: string;
  countryFlag: string;
  category: string;
  sector: string;
  source: string;
  sourceUrl: string;
  originalUrl?: string;
  date: string;
  featured?: boolean;
  views?: number;
  readTime?: number;
  keyPoints?: string[];
  impact?: ArticleImpact[];
  quote?: string;
  quoteAuthor?: string;
}

export const featuredArticle: Article = {
  id: "feat-1",
  title: "Flutterwave : Comment Olugbenga Agboola a bâti une licorne africaine de 3 milliards de dollars",
  summary: "Parti de Lagos avec une vision simple — faciliter les paiements en Afrique — Olugbenga Agboola a transformé Flutterwave en l\'une des fintech les plus valorisées du continent. Une success story qui inspire des milliers de jeunes entrepreneurs africains.",
  image: "https://public.readdy.ai/ai/img_res/73d4e229f1ada3a67160d682aacd5043.jpg",
  entrepreneur: "Olugbenga Agboola",
  country: "Nigeria",
  countryFlag: "🇳🇬",
  category: "Success Story",
  sector: "Fintech",
  source: "TechCabal",
  sourceUrl: "https://techcabal.com",
  originalUrl: "https://techcabal.com/2023/03/01/flutterwave-ceo-gbenga-agboola-on-building-africas-most-valuable-startup/",
  date: "2026-04-01",
  featured: true,
  views: 48200,
  readTime: 8,
  keyPoints: [
    "Fondée en 2016 à Lagos, Flutterwave est devenue la startup africaine la plus valorisée avec 3 milliards de dollars",
    "La plateforme traite plus de 200 millions de transactions par an dans 34 pays africains",
    "Olugbenga Agboola a travaillé chez Google et PayPal avant de lancer Flutterwave",
    "La startup a levé plus de 474 millions de dollars auprès d\'investisseurs comme Tiger Global et Avenir Growth",
    "Flutterwave permet aux entreprises africaines d\'accepter des paiements en ligne en quelques minutes"
  ],
  impact: [
    { value: "3 Mds$", label: "Valorisation", icon: "ri-money-dollar-circle-line" },
    { value: "34", label: "Pays africains", icon: "ri-global-line" },
    { value: "200M+", label: "Transactions/an", icon: "ri-exchange-line" },
    { value: "900+", label: "Employés", icon: "ri-team-line" }
  ],
  quote: "Mon rêve était simple : faire en sorte que n\'importe quelle entreprise africaine puisse accepter des paiements du monde entier en quelques clics.",
  quoteAuthor: "Olugbenga Agboola, CEO Flutterwave"
};

// ✅ Strive Masiyiwa retiré (African Business → 404)
export const successStories: Article[] = [
  {
    id: "ss-tope1",
    title: "Tope Awotona : Le Nigérian qui a tout misé sur Calendly pour créer une startup à 3 milliards de dollars",
    summary: "Né à Lagos, Tope Awotona a vidé son compte retraite de 200 000 dollars pour bootstrapper Calendly en 2013. Après trois échecs consécutifs, il a transformé un simple outil de prise de rendez-vous en une startup valorisée à 3 milliards de dollars.",
    image: "https://readdy.ai/api/search-image?query=nigerian%20african%20entrepreneur%20Atlanta%20USA%20tech%20startup%20founder%20confident%20professional%20modern%20office%20portrait%20success%20story%20billion%20dollar%20company%20warm%20lighting&width=600&height=400&seq=ss-tope1&orientation=landscape",
    entrepreneur: "Tope Awotona",
    country: "Nigeria → USA",
    countryFlag: "🇳🇬🇺🇸",
    category: "Success Story",
    sector: "Tech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2021/01/26/how-atlantas-calendly-turned-a-scheduling-nightmare-into-a-3b-startup/",
    date: "2021-01-26",
    views: 0,
    readTime: 8,
    keyPoints: [
      "Tope Awotona a vidé son compte retraite de 200 000 dollars pour bootstrapper Calendly en 2013",
      "Avant Calendly, il avait fondé trois startups qui ont toutes échoué — un site de rencontres, des projecteurs et des outils de jardinage",
      "Calendly a atteint une valorisation de 3 milliards de dollars en 2021 sans jamais avoir levé de fonds avant cette date",
      "La startup compte plus de 10 millions d\'utilisateurs dans 150 pays et génère des centaines de millions de dollars de revenus",
      "Tope Awotona est l\'un des rares entrepreneurs africains à avoir bootstrappé une startup jusqu\'au statut de licorne"
    ],
    quote: "J\'ai tout perdu trois fois avant Calendly. Mais chaque échec m\'a appris quelque chose d\'essentiel. La persévérance n\'est pas un choix — c\'est une nécessité.",
    quoteAuthor: "Tope Awotona, Fondateur & CEO de Calendly"
  },
  {
    id: "ss-mnt1",
    title: "Mounir Nakhla : L\'Égyptien qui crée la première licorne privée d\'Égypte avec MNT-Halan",
    summary: "Fondateur de MNT-Halan, Mounir Nakhla a levé 400 millions de dollars en janvier 2023, faisant de sa fintech la première licorne privée d\'Égypte. Sa plateforme de super-app financière sert des millions d\'Égyptiens non-bancarisés avec du crédit, des paiements et du e-commerce.",
    image: "https://readdy.ai/api/search-image?query=egyptian%20african%20entrepreneur%20fintech%20founder%20confident%20professional%20modern%20Cairo%20office%20portrait%20success%20story%20unicorn%20billion%20dollar%20startup%20warm%20lighting&width=600&height=400&seq=ss-mnt1&orientation=landscape",
    entrepreneur: "Mounir Nakhla",
    country: "Égypte",
    countryFlag: "🇪🇬",
    category: "Success Story",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2023/01/31/egyptian-financial-services-provider-mnt-halan-gets-1b-valuation-after-securing-400m/",
    date: "2023-01-31",
    views: 0,
    readTime: 7,
    keyPoints: [
      "MNT-Halan est devenue la première licorne privée d\'Égypte en janvier 2023 avec une valorisation d\'1 milliard de dollars",
      "La startup a levé 400 millions de dollars en equity et dette auprès d\'investisseurs locaux et internationaux",
      "La plateforme sert des millions d\'Égyptiens non-bancarisés avec du crédit, des paiements et du e-commerce",
      "MNT-Halan a accordé plus de 1 milliard de dollars de prêts à plus de 4 millions de clients en Égypte",
      "La startup prévoit de s\'étendre dans d\'autres marchés africains et au Moyen-Orient"
    ],
    quote: "En Égypte, des millions de personnes n\'ont pas accès aux services bancaires traditionnels. MNT-Halan est leur banque, leur boutique et leur source de crédit — tout en un.",
    quoteAuthor: "Mounir Nakhla, Fondateur & CEO de MNT-Halan"
  },
  {
    id: "ss-esusu1",
    title: "Wemimo Abbey : Le Nigérian qui aide les immigrés africains à construire leur crédit aux États-Unis avec Esusu",
    summary: "Co-fondateur d\'Esusu, Wemimo Abbey a levé 130 millions de dollars avec SoftBank Vision Fund 2 en 2022, atteignant le statut de licorne. Sa fintech aide les immigrés et minorités américaines à construire leur score de crédit via les paiements de loyer.",
    image: "https://readdy.ai/api/search-image?query=nigerian%20african%20entrepreneur%20New%20York%20USA%20fintech%20startup%20founder%20confident%20professional%20modern%20office%20portrait%20success%20story%20unicorn%20credit%20building%20diaspora&width=600&height=400&seq=ss-esusu1&orientation=landscape",
    entrepreneur: "Wemimo Abbey",
    country: "Nigeria → USA",
    countryFlag: "🇳🇬🇺🇸",
    category: "Success Story",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/01/27/esusu-becomes-unicorn-with-softbank-vision-fund-2-led-130m-funding/",
    date: "2022-01-27",
    views: 0,
    readTime: 7,
    keyPoints: [
      "Esusu a levé 130 millions de dollars avec SoftBank Vision Fund 2 en janvier 2022, atteignant le statut de licorne",
      "La plateforme aide les immigrés et minorités à construire leur score de crédit via les paiements de loyer",
      "Plus de 2,5 millions de foyers américains utilisent Esusu pour améliorer leur accès au crédit",
      "Wemimo Abbey a co-fondé Esusu après avoir lui-même vécu sans score de crédit en arrivant aux États-Unis depuis le Nigeria",
      "Esusu a généré plus de 3,4 milliards de dollars de volume de loyers signalés aux agences de crédit"
    ],
    quote: "Je suis arrivé aux États-Unis sans crédit, sans réseau, sans rien. Esusu est la startup que j\'aurais voulu avoir quand j\'avais besoin d\'elle.",
    quoteAuthor: "Wemimo Abbey, Co-fondateur & CEO d\'Esusu"
  }
];

export const startups: Article[] = [
  {
    id: "new-1",
    title: "Moniepoint : La fintech nigériane qui devient licorne avec 110M$ de Google",
    summary: "Moniepoint a levé 110 millions de dollars en octobre 2024 avec Google et DPI comme investisseurs, atteignant une valorisation de plus d\'un milliard de dollars. La plateforme sert des millions de PME nigérianes avec des solutions de paiement, banking et gestion d\'entreprise intégrées.",
    image: "https://readdy.ai/api/search-image?query=nigerian%20fintech%20startup%20unicorn%20Lagos%20modern%20office%20payment%20technology%20business%20banking%20professional%20confident%20entrepreneur%20portrait%20warm%20lighting&width=600&height=400&seq=new1&orientation=landscape",
    entrepreneur: "Tosin Eniolorunda",
    country: "Nigeria",
    countryFlag: "🇳🇬",
    category: "Startup",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/10/29/google-dpi-backs-moniepoint-in-110m-round/",
    date: "2024-10-29",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Moniepoint a levé 110 millions de dollars en Série C en octobre 2024, atteignant le statut de licorne",
      "Google Africa Investment Fund et DPI figurent parmi les investisseurs principaux du tour",
      "La plateforme traite des paiements pour des millions de PME à travers le Nigeria",
      "Moniepoint combine paiements digitaux, banking et outils de gestion d\'entreprise en une seule app",
      "La startup prévoit d\'utiliser les fonds pour s\'étendre à d\'autres marchés africains"
    ],
    quote: "Notre mission est simple : donner aux petites entreprises africaines les mêmes outils financiers que les grandes corporations mondiales.",
    quoteAuthor: "Tosin Eniolorunda, CEO de Moniepoint"
  },
  {
    id: "new-2",
    title: "NALA : La fintech tanzanienne qui lève 40M$ pour révolutionner les transferts d\'argent africains",
    summary: "Fondée par Benjamin Fernandes, NALA a levé 40 millions de dollars en Série A en juillet 2024. La startup a multiplié ses revenus par 10 et atteint la rentabilité avant ce tour de table historique.",
    image: "https://readdy.ai/api/search-image?query=tanzanian%20african%20fintech%20startup%20money%20transfer%20remittance%20app%20mobile%20payment%20Dar%20es%20Salaam%20modern%20tech%20entrepreneur%20confident&width=600&height=400&seq=new2&orientation=landscape",
    entrepreneur: "Benjamin Fernandes",
    country: "Tanzanie",
    countryFlag: "🇹🇿",
    category: "Startup",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/07/09/nala-raises-40m-series-a/",
    date: "2024-07-09",
    views: 0,
    readTime: 5,
    keyPoints: [
      "NALA a levé 40 millions de dollars en Série A en juillet 2024",
      "La startup a multiplié ses revenus par 10 et atteint la rentabilité avant la levée",
      "Acrew Capital, DST Global et Norrsken22 figurent parmi les investisseurs du tour",
      "La plateforme B2B Rafiki permet aux entreprises mondiales d\'envoyer des paiements directement en Afrique",
      "NALA sert près de 500 000 clients et prévoit de s\'étendre en Asie et en Amérique Latine"
    ],
    quote: "Nous construisons les rails de paiement que l\'Afrique mérite — rapides, fiables et abordables pour tous.",
    quoteAuthor: "Benjamin Fernandes, Fondateur de NALA"
  },
  {
    id: "new-5",
    title: "TymeBank : La néobanque sud-africaine qui devient licorne et s\'attaque à l\'Asie du Sud-Est",
    summary: "TymeBank a rejoint le club des licornes africaines fin 2024. Fondée par Coen Jonker, la néobanque sert 10 millions de clients en Afrique du Sud et aux Philippines, prouvant que le modèle africain peut conquérir le monde.",
    image: "https://readdy.ai/api/search-image?query=south%20african%20neobank%20digital%20banking%20startup%20unicorn%20Cape%20Town%20Johannesburg%20modern%20fintech%20entrepreneur%20confident%20professional%20portrait&width=600&height=400&seq=new5&orientation=landscape",
    entrepreneur: "Coen Jonker",
    country: "Afrique du Sud",
    countryFlag: "🇿🇦",
    category: "Startup",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/11/14/africas-newest-fintech-unicorns-are-winning-by-keeping-their-feet-on-the-ground/",
    date: "2024-11-14",
    views: 0,
    readTime: 7,
    keyPoints: [
      "TymeBank a atteint le statut de licorne fin 2024 avec une valorisation de plus d\'un milliard de dollars",
      "La néobanque sert 10 millions de clients en Afrique du Sud et aux Philippines",
      "TymeBank combine des points de contact physiques (kiosques) avec une app 100% digitale",
      "Le modèle hybride digital-physique est cité comme clé du succès dans les marchés émergents",
      "La banque prévoit d\'étendre son modèle à d\'autres marchés asiatiques et africains"
    ],
    quote: "Les gens pensent que la banque digitale signifie 100% en ligne. En Afrique, le succès vient de combiner le meilleur des deux mondes.",
    quoteAuthor: "Coen Jonker, Fondateur de TymeBank"
  },
  {
    id: "new-6",
    title: "Wasoko x MaxAB : La fusion qui crée un géant du commerce B2B africain à 600 milliards de dollars",
    summary: "En août 2024, Wasoko (Kenya) et MaxAB (Égypte) ont finalisé leur fusion, créant la plus grande plateforme B2B de distribution informelle en Afrique. Cette consolidation historique cible un marché de 600 milliards de dollars.",
    image: "https://readdy.ai/api/search-image?query=african%20B2B%20commerce%20merger%20startup%20Kenya%20Egypt%20distribution%20supply%20chain%20informal%20retail%20market%20modern%20warehouse%20logistics%20tech&width=600&height=400&seq=new6&orientation=landscape",
    entrepreneur: "Daniel Yu & Belal El-Megharbel",
    country: "Kenya & Égypte",
    countryFlag: "🇰🇪🇪🇬",
    category: "Startup",
    sector: "Commerce",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/08/01/wasoko-and-maxab-complete-merger/",
    date: "2024-08-01",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Wasoko et MaxAB ont finalisé leur fusion en août 2024, créant le plus grand acteur B2B informel d\'Afrique",
      "La fusion cible un marché de distribution informelle estimé à 600 milliards de dollars",
      "L\'opération est l\'une des consolidations les plus complexes de l\'histoire de la tech africaine",
      "La nouvelle entité opère en Afrique de l\'Est et en Afrique du Nord avec des milliers de détaillants",
      "La stratégie combine la logistique de Wasoko et la technologie de paiement de MaxAB"
    ],
    quote: "Cette fusion n\'est pas une retraite — c\'est une offensive. Ensemble, nous avons la masse critique pour transformer le commerce africain.",
    quoteAuthor: "Daniel Yu, Co-CEO de la nouvelle entité"
  },
  {
    id: "st-1",
    title: "Moove Africa : La startup qui démocratise la mobilité pour les chauffeurs africains",
    summary: "Moove fournit des véhicules à crédit aux chauffeurs Uber en Afrique. Valorisée à 750 millions de dollars, elle opère dans 13 villes africaines et a changé la vie de 20 000 chauffeurs.",
    image: "https://readdy.ai/api/search-image?query=african%20mobility%20startup%20ride%20sharing%20vehicles%20drivers%20Lagos%20Nigeria%20modern%20urban%20transportation%20fleet&width=600&height=400&seq=st1&orientation=landscape",
    entrepreneur: "Ladi Delano & Jide Odunsi",
    country: "Nigeria",
    countryFlag: "🇳🇬",
    category: "Startup",
    sector: "Mobilité",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/03/14/moove-raises-105m-to-scale-its-vehicle-financing-product-across-asia-europe-and-mena/",
    date: "2026-04-02",
    views: 22400,
    readTime: 5
  },
  {
    id: "st-2",
    title: "Yoco : La fintech sud-africaine qui équipe 200 000 petits commerçants",
    summary: "Yoco fabrique des terminaux de paiement abordables pour les PME africaines. Avec 400 millions de dollars levés, elle transforme le commerce informel en Afrique du Sud.",
    image: "https://readdy.ai/api/search-image?query=south%20african%20fintech%20payment%20terminal%20small%20business%20merchant%20modern%20technology%20startup%20Cape%20Town&width=600&height=400&seq=st2&orientation=landscape",
    entrepreneur: "Katlego Maphai",
    country: "Afrique du Sud",
    countryFlag: "🇿🇦",
    category: "Startup",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2021/07/26/south-african-payments-startup-yoco-raises-83m-series-c-led-by-dragoneer/",
    date: "2026-03-25",
    views: 18700,
    readTime: 4
  },
  {
    id: "st-3",
    title: "Wasoko : Révolutionner la distribution B2B en Afrique de l\'Est",
    summary: "Wasoko connecte directement les fabricants aux détaillants informels via une app mobile. Présente dans 6 pays, la startup a levé 125 millions de dollars en Série B.",
    image: "https://readdy.ai/api/search-image?query=african%20B2B%20distribution%20startup%20East%20Africa%20supply%20chain%20mobile%20app%20warehouse%20logistics%20modern&width=600&height=400&seq=st3&orientation=landscape",
    entrepreneur: "Daniel Yu",
    country: "Kenya",
    countryFlag: "🇰🇪",
    category: "Startup",
    sector: "Commerce",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/03/17/b2b-e-commerce-platform-wasoko-raises-125m-series-b-at-625m-valuation/",
    date: "2026-03-18",
    views: 15200,
    readTime: 6
  },
  {
    id: "st-4",
    title: "Djamo : La néobanque ivoirienne qui bancarise la Côte d\'Ivoire",
    summary: "Djamo offre un compte bancaire gratuit avec carte Visa à tous les Ivoiriens. En 3 ans, la startup a atteint 500 000 utilisateurs et lève 14 millions de dollars.",
    image: "https://readdy.ai/api/search-image?query=Ivory%20Coast%20neobank%20fintech%20mobile%20banking%20app%20Abidjan%20young%20african%20users%20smartphone%20modern&width=600&height=400&seq=st4&orientation=landscape",
    entrepreneur: "Hassan Bourgi",
    country: "Côte d\'Ivoire",
    countryFlag: "🇨🇮",
    category: "Startup",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/11/09/ivorian-neobank-djamo-raises-14m-to-expand-in-francophone-africa/",
    date: "2026-03-12",
    views: 29600,
    readTime: 5
  }
];

// ✅ Cardiopad (BBC 2014 → 404) et M-KOPA (Guardian 2014 → 404) retirés
// ✅ Beth Koigi : URL corrigée vers BBC 2024
export const innovations: Article[] = [
  {
    id: "new-3",
    title: "InstaDeep : L\'IA tunisienne rachetée 682M$ par BioNTech, la plus grande acquisition tech africaine",
    summary: "Karim Beguir a co-fondé InstaDeep à Tunis avec deux ordinateurs portables. En janvier 2023, BioNTech a racheté la plus grande entreprise d\'IA africaine pour 682 millions de dollars, un record absolu pour une startup du continent.",
    image: "https://readdy.ai/api/search-image?query=tunisian%20african%20AI%20artificial%20intelligence%20startup%20founder%20entrepreneur%20tech%20acquisition%20success%20modern%20office%20confident%20professional%20portrait&width=600&height=400&seq=new3&orientation=landscape",
    entrepreneur: "Karim Beguir",
    country: "Tunisie",
    countryFlag: "🇹🇳",
    category: "Innovation",
    sector: "Intelligence Artificielle",
    source: "BBC",
    sourceUrl: "https://www.bbc.com",
    originalUrl: "https://www.bbc.com/news/business-64227910",
    date: "2023-01-10",
    views: 0,
    readTime: 8,
    keyPoints: [
      "BioNTech a racheté InstaDeep pour 682 millions de dollars en janvier 2023, un record pour une startup africaine",
      "Karim Beguir a fondé InstaDeep à Tunis avec seulement deux ordinateurs portables",
      "InstaDeep était la plus grande entreprise d\'IA d\'Afrique avant son acquisition",
      "La startup utilisait le machine learning pour optimiser des chaînes logistiques complexes",
      "L\'acquisition permet à BioNTech d\'intégrer l\'IA dans la découverte de nouveaux médicaments"
    ],
    quote: "J\'ai commencé avec deux laptops et une idée. L\'Afrique peut produire des entreprises tech de classe mondiale — InstaDeep en est la preuve.",
    quoteAuthor: "Karim Beguir, Co-fondateur d\'InstaDeep"
  },
  {
    id: "new-4",
    title: "Beth Koigi : La Kényane qui fabrique de l\'eau à partir de l\'air pour les zones arides",
    summary: "Beth Koigi a co-fondé Majik Water, une entreprise sociale kényane qui utilise des générateurs atmosphériques pour extraire de l\'eau potable directement de l\'air. Sa technologie alimente 40 unités dans les régions les plus arides du Kenya.",
    image: "https://readdy.ai/api/search-image?query=kenyan%20woman%20entrepreneur%20clean%20water%20innovation%20atmospheric%20generator%20arid%20region%20Africa%20social%20enterprise%20modern%20technology%20sustainable&width=600&height=400&seq=new4&orientation=landscape",
    entrepreneur: "Beth Koigi",
    country: "Kenya",
    countryFlag: "🇰🇪",
    category: "Innovation",
    sector: "Eau & Environnement",
    source: "BBC",
    sourceUrl: "https://www.bbc.com",
    originalUrl: "https://www.bbc.com/news/articles/cd11nnwp646o",
    date: "2024-05-27",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Majik Water utilise des générateurs atmosphériques pour extraire l\'eau potable de l\'humidité de l\'air",
      "La technologie produit jusqu\'à 500 litres d\'eau par jour dans des zones sans infrastructure hydrique",
      "Beth Koigi gère 40 unités déployées dans les régions arides du Kenya",
      "L\'initiative a été inspirée par la sécheresse dévastatrice de 2016 au Kenya",
      "Le marché mondial des générateurs d\'eau atmosphérique est estimé à 13,5 milliards de dollars d\'ici 2032"
    ],
    quote: "L\'eau est un droit humain fondamental. Si la nature peut la créer à partir de l\'air, nous pouvons la rendre accessible à tous.",
    quoteAuthor: "Beth Koigi, Co-fondatrice de Majik Water"
  }
];

export const femmesEntrepreneures: Article[] = [
  {
    id: "fe-ba1",
    title: "Fatoumata Bâ : La Guinéenne qui lève 78M$ pour financer les femmes entrepreneures africaines",
    summary: "Fondatrice de Janngo Capital, Fatoumata Bâ a clôturé son deuxième fonds à 78 millions de dollars en octobre 2024, dépassant son objectif de 20%. Avec un mandat \"gender-equal\", 56% de son portefeuille est fondé ou dirigé par des femmes.",
    image: "https://readdy.ai/api/search-image?query=guinean%20african%20woman%20venture%20capitalist%20investor%20entrepreneur%20founder%20confident%20professional%20modern%20office%20Conakry%20portrait%20warm%20lighting%20startup%20fund&width=600&height=400&seq=fe-ba1&orientation=landscape",
    entrepreneur: "Fatoumata Bâ",
    country: "Guinée",
    countryFlag: "🇬🇳",
    category: "Femme Entrepreneuse",
    sector: "Finance",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/10/29/african-vc-firm-janngo-capital-closes-second-fund-at-78m/",
    date: "2024-10-29",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Janngo Capital a clôturé son deuxième fonds à 78 millions de dollars en octobre 2024, dépassant son objectif de 20%",
      "Le fonds a un mandat \"gender-equal\" : 56% du portefeuille est fondé ou dirigé par des femmes",
      "Fatoumata Bâ est la première femme africaine à lever deux fonds de capital-risque successifs dépassant 50M$",
      "Les investisseurs incluent la Banque Africaine de Développement, le DFC américain et la Banque Européenne d\'Investissement",
      "Janngo Capital investit de la pré-amorçage à la Série B dans 21 startups africaines dans 11 pays"
    ],
    quote: "L\'Afrique représente 17% de la population mondiale mais attire moins de 1% du capital-risque global. Notre objectif est de changer ça — en mettant les femmes au cœur de la solution.",
    quoteAuthor: "Fatoumata Bâ, Fondatrice de Janngo Capital"
  },
  {
    id: "fe-kasha1",
    title: "Joanna Bichsel : La CEO de Kasha qui révolutionne l\'accès aux soins de santé pour les femmes africaines",
    summary: "Fondatrice de Kasha, Joanna Bichsel a levé 21 millions de dollars en Série B en juillet 2023 pour étendre sa plateforme de distribution de produits de santé féminine à travers l\'Afrique.",
    image: "https://readdy.ai/api/search-image?query=woman%20entrepreneur%20health%20startup%20Rwanda%20Kenya%20founder%20confident%20modern%20portrait%20professional%20healthcare%20africa%20digital%20platform%20warm%20lighting&width=600&height=400&seq=fe-kasha1&orientation=landscape",
    entrepreneur: "Joanna Bichsel",
    country: "Rwanda & Kenya",
    countryFlag: "🇷🇼🇰🇪",
    category: "Femme Entrepreneuse",
    sector: "Santé",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2023/07/20/kasha-raises-21m-series-b-led-by-knife-capital-to-expand-health-access-platform-across-africa/",
    date: "2023-07-20",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Kasha a levé 21 millions de dollars en Série B en juillet 2023, menée par Knife Capital",
      "La plateforme distribue des produits de santé féminine et des médicaments dans les zones reculées du Rwanda et du Kenya",
      "Kasha a été fondée en 2016 après que Joanna Bichsel a constaté le manque d\'accès aux produits de santé pour les femmes africaines",
      "La startup compte plus de 200 000 clientes actives et livre dans plus de 200 localités",
      "Kasha prévoit d\'utiliser les fonds pour s\'étendre en Afrique de l\'Ouest et en Afrique du Sud"
    ],
    quote: "Les femmes africaines méritent le même accès aux soins de santé que n\'importe qui dans le monde. Kasha est notre réponse à cette inégalité fondamentale.",
    quoteAuthor: "Joanna Bichsel, Fondatrice & CEO de Kasha"
  },
  {
    id: "fe-new1",
    title: "Nelly Chatue-Diop : La Camerounaise qui démocratise la crypto en Afrique francophone",
    summary: "Fondatrice d\'Ejara, Nelly Chatue-Diop a levé 8 millions de dollars pour offrir aux Africains francophones un accès simple à la crypto et à l\'épargne digitale. Une pionnière de la Web3 en Afrique.",
    image: "https://readdy.ai/api/search-image?query=cameroonian%20african%20woman%20entrepreneur%20crypto%20blockchain%20fintech%20startup%20founder%20confident%20professional%20modern%20Douala%20portrait%20warm%20lighting&width=600&height=400&seq=fe-new1&orientation=landscape",
    entrepreneur: "Nelly Chatue-Diop",
    country: "Cameroun",
    countryFlag: "🇨🇲",
    category: "Femme Entrepreneuse",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/11/28/cameroonian-crypto-and-savings-platform-ejara-raises-8m-led-by-anthemis-and-dragonfly/",
    date: "2022-11-28",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Ejara a levé 8 millions de dollars en Série A auprès d\'Anthemis et Dragonfly Capital",
      "La plateforme permet aux Africains francophones d\'accéder à la crypto et à l\'épargne digitale sans compte bancaire",
      "Nelly Chatue-Diop a été l\'une des rares femmes noires à lever plus de 10 millions de dollars en Afrique",
      "Ejara opère dans 7 pays d\'Afrique francophone dont le Sénégal, la Côte d\'Ivoire et le Cameroun",
      "La startup utilise la blockchain pour offrir des produits financiers accessibles dès 1 000 FCFA"
    ],
    quote: "En Afrique francophone, des millions de personnes n\'ont pas de compte bancaire mais ont un smartphone. Ejara est leur banque.",
    quoteAuthor: "Nelly Chatue-Diop, Fondatrice d\'Ejara"
  },
  {
    id: "fe-new3",
    title: "Kate Kallot : L\'IA spatiale kényane qui révolutionne l\'agriculture africaine avec Amini",
    summary: "Fondatrice d\'Amini, Kate Kallot utilise des données satellitaires et l\'intelligence artificielle pour fournir aux agriculteurs africains des informations précises sur la santé de leurs sols. Sa startup a levé 4 millions de dollars avec Salesforce Ventures.",
    image: "https://readdy.ai/api/search-image?query=kenyan%20african%20woman%20entrepreneur%20AI%20space%20technology%20satellite%20agriculture%20startup%20founder%20modern%20Nairobi%20confident%20professional%20portrait&width=600&height=400&seq=fe-new3&orientation=landscape",
    entrepreneur: "Kate Kallot",
    country: "Kenya",
    countryFlag: "🇰🇪",
    category: "Femme Entrepreneuse",
    sector: "AgriTech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2023/11/07/amini-raises-4m-to-use-ai-and-space-tech-to-help-african-farmers/",
    date: "2023-11-07",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Amini a levé 4 millions de dollars en seed avec Salesforce Ventures et Female Founders Fund",
      "La plateforme combine données satellitaires et IA pour analyser la santé des sols africains",
      "Kate Kallot est une ancienne dirigeante de NVIDIA qui a tout quitté pour lancer Amini",
      "La startup cible les 60% d\'agriculteurs africains qui n\'ont aucun accès aux données agronomiques",
      "Amini opère au Kenya, en Tanzanie et en Éthiopie avec des plans d\'expansion rapide"
    ],
    quote: "L\'Afrique possède 60% des terres arables mondiales non exploitées. Avec les bonnes données, on peut nourrir la planète.",
    quoteAuthor: "Kate Kallot, Fondatrice d\'Amini"
  }
];

// ✅ Kelvin Doe retiré (CNN 2012 → 404)
export const jeunesTalents: Article[] = [
  {
    id: "jt-new1",
    title: "Neo Hutiri : Le Sud-Africain qui distribue les médicaments en 36 secondes grâce à des casiers connectés",
    summary: "Diagnostiqué tuberculeux à 27 ans, Neo Hutiri a inventé Pelebox — des casiers intelligents qui permettent aux patients chroniques de récupérer leurs médicaments en moins de 36 secondes. Son invention est déployée dans 123 établissements de santé en Afrique australe.",
    image: "https://readdy.ai/api/search-image?query=young%20south%20african%20engineer%20inventor%20smart%20locker%20medication%20healthcare%20innovation%20award%20Royal%20Academy%20Engineering%20modern%20portrait%20confident&width=600&height=400&seq=jt-new1&orientation=landscape",
    entrepreneur: "Neo Hutiri",
    country: "Afrique du Sud",
    countryFlag: "🇿🇦",
    category: "Jeune Talent",
    sector: "Santé",
    source: "CNN",
    sourceUrl: "https://www.cnn.com",
    originalUrl: "https://www.cnn.com/2024/02/01/africa/africa-innovation-prize-royal-academy-of-engineering-spc-intl",
    date: "2024-02-01",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Pelebox permet aux patients de récupérer leurs médicaments en moins de 36 secondes via un code SMS",
      "Neo Hutiri a inventé Pelebox après avoir lui-même attendu des heures pour ses médicaments contre la tuberculose",
      "Il a reçu la médaille spéciale de la Royal Academy of Engineering en 2024 pour 10 ans d\'innovation africaine",
      "Le système est déployé dans 123 établissements de santé en Afrique du Sud, Namibie et Botswana",
      "Pelebox réduit les files d\'attente de plus de 3 heures à quelques secondes pour les malades chroniques"
    ],
    quote: "J\'ai vécu l\'humiliation d\'attendre des heures pour mes médicaments. Personne ne devrait vivre ça. Pelebox est ma réponse.",
    quoteAuthor: "Neo Hutiri, Fondateur de Pelebox"
  },
  {
    id: "jt-new2",
    title: "Chowdeck : Le Nigérian de 26 ans qui veut créer le super-app de livraison alimentaire africain",
    summary: "Femi Aluko a fondé Chowdeck à Lagos après le départ de Jumia Food. En 2024, sa startup soutenue par Y Combinator a levé 2,5 millions de dollars et traite 2,4 milliards de nairas de commandes par mois dans 8 villes nigérianes.",
    image: "https://readdy.ai/api/search-image?query=young%20nigerian%20entrepreneur%20food%20delivery%20startup%20Lagos%20founder%20confident%20modern%20tech%20office%20YCombinator%20portrait%20vibrant%20urban&width=600&height=400&seq=jt-new2&orientation=landscape",
    entrepreneur: "Femi Aluko",
    country: "Nigeria",
    countryFlag: "🇳🇬",
    category: "Jeune Talent",
    sector: "Tech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2024/04/30/nigerias-yc-backed-chowdeck-hopes-to-scale-food-delivery-a-notoriously-tough-market-with-2-5m-funding/",
    date: "2024-04-30",
    views: 0,
    readTime: 5,
    keyPoints: [
      "Chowdeck a levé 2,5 millions de dollars en seed avec Y Combinator, Goodwater Capital et les fondateurs de Paystack",
      "La startup a multiplié ses revenus par 12 entre 2022 et 2023 malgré un marché très difficile",
      "Chowdeck opère dans 8 villes nigérianes avec plus de 3 000 livreurs et 500 000 utilisateurs actifs",
      "La plateforme livre en moyenne en 30 minutes, un record pour le marché nigérian",
      "Femi Aluko a lancé Chowdeck après le retrait de Jumia Food du Nigeria en 2023"
    ],
    quote: "Quand Jumia Food est parti, tout le monde a dit que la livraison alimentaire était impossible au Nigeria. On a décidé de prouver le contraire.",
    quoteAuthor: "Femi Aluko, Fondateur de Chowdeck"
  },
  {
    id: "jt-new3",
    title: "Faraja Nyalandu : L\'ancienne Miss Tanzania qui connecte 5 millions d\'élèves à l\'éducation digitale",
    summary: "Avocate et ancienne Miss Tanzania, Faraja Nyalandu a fondé Shule Direct, la plus grande plateforme d\'éducation digitale de Tanzanie. Sa startup fournit des contenus pédagogiques gratuits à 5 millions d\'élèves dans tout le pays.",
    image: "https://readdy.ai/api/search-image?query=tanzanian%20african%20woman%20entrepreneur%20education%20technology%20startup%20founder%20confident%20modern%20Dar%20es%20Salaam%20portrait%20young%20professional%20edtech&width=600&height=400&seq=jt-new3&orientation=landscape",
    entrepreneur: "Faraja Nyalandu",
    country: "Tanzanie",
    countryFlag: "🇹🇿",
    category: "Jeune Talent",
    sector: "Éducation",
    source: "CNN",
    sourceUrl: "https://www.cnn.com",
    originalUrl: "https://www.cnn.com/2025/05/05/world/video/african-voices-changemakers-kingsley-pungong-cameroon-faraja-nyalandu-tanzania-entrepreneurship-spc",
    date: "2025-05-05",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Shule Direct est la plus grande plateforme d\'éducation digitale de Tanzanie avec 5 millions d\'élèves",
      "Faraja Nyalandu est avocate et ancienne Miss Tanzania reconvertie en entrepreneuse tech",
      "La plateforme fournit des contenus pédagogiques gratuits alignés sur le programme national tanzanien",
      "Shule Direct opère dans des zones rurales sans connexion internet stable grâce à des contenus hors-ligne",
      "Elle a été présentée par CNN African Voices Changemakers comme l\'une des voix les plus inspirantes d\'Afrique"
    ],
    quote: "En Tanzanie, des millions d\'enfants n\'ont pas accès à des manuels scolaires. Shule Direct est leur bibliothèque numérique.",
    quoteAuthor: "Faraja Nyalandu, Fondatrice de Shule Direct"
  },
  {
    id: "jt-3",
    title: "Ludwick Marishane : L\'étudiant sud-africain qui a inventé le bain sans eau",
    summary: "À 17 ans, Ludwick Marishane a inventé DryBath, un gel qui remplace le bain avec de l\'eau. Google l\'a nommé meilleur jeune entrepreneur mondial. Son invention aide des millions de personnes.",
    image: "https://readdy.ai/api/search-image?query=young%20south%20african%20student%20inventor%20entrepreneur%20innovation%20product%20startup%20youth%20talent%20modern%20Johannesburg&width=600&height=400&seq=jt3&orientation=landscape",
    entrepreneur: "Ludwick Marishane",
    country: "Afrique du Sud",
    countryFlag: "🇿🇦",
    category: "Jeune Talent",
    sector: "Santé",
    source: "TED",
    sourceUrl: "https://www.ted.com",
    originalUrl: "https://www.ted.com/talks/ludwick_marishane_a_bath_without_water",
    date: "2026-03-16",
    views: 28700,
    readTime: 5
  }
];

// ✅ Tokunbo Ishmael retirée (African Business → 404)
export const diasporaAfricaine: Article[] = [
  {
    id: "dia-new2",
    title: "Olugbenga Olubanjo : Le Nigérian de Toronto qui loue des batteries solaires portables aux foyers sans électricité",
    summary: "Fondateur de Reeddi, Olugbenga Olubanjo a quitté le Nigeria pour le Canada et a créé un système de location de batteries solaires portables pour les foyers africains sans accès au réseau électrique. Sa startup a été finaliste du prestigieux Earthshot Prize.",
    image: "https://readdy.ai/api/search-image?query=nigerian%20african%20entrepreneur%20Toronto%20Canada%20diaspora%20solar%20energy%20battery%20portable%20startup%20founder%20confident%20modern%20portrait%20clean%20energy%20innovation&width=600&height=400&seq=dia-new2&orientation=landscape",
    entrepreneur: "Olugbenga Olubanjo",
    country: "Nigeria → Canada",
    countryFlag: "🇳🇬🇨🇦",
    category: "Diaspora Africaine",
    sector: "Énergie",
    source: "CNN",
    sourceUrl: "https://www.cnn.com",
    originalUrl: "https://www.cnn.com/2023/03/22/africa/reeddi-capsules-battery-nigeria-spc-intl",
    date: "2023-03-22",
    views: 0,
    readTime: 7,
    keyPoints: [
      "Reeddi a été finaliste du Earthshot Prize, le prix environnemental le plus prestigieux au monde",
      "La startup loue des batteries solaires portables pour moins de 0,50$ par jour aux foyers nigérians",
      "Le système fonctionne comme un \"Airbnb de l\'énergie\" — les clients échangent leur batterie déchargée contre une chargée",
      "Reeddi cible les 600 millions d\'Africains qui n\'ont pas accès à un réseau électrique fiable",
      "Olugbenga Olubanjo a développé le concept au Canada après avoir grandi sans électricité stable au Nigeria"
    ],
    quote: "J\'ai grandi au Nigeria avec des coupures de courant quotidiennes. Au Canada, j\'ai réalisé que la technologie pouvait résoudre ce problème pour des millions de personnes.",
    quoteAuthor: "Olugbenga Olubanjo, Fondateur de Reeddi"
  },
  {
    id: "dia-new1",
    title: "Jessica Anuna : La Nigériane de Cambridge qui connecte l\'Afrique au commerce mondial depuis Londres",
    summary: "Diplômée de Cambridge, Jessica Anuna a fondé Klasha depuis Londres pour permettre aux Africains de faire leurs achats sur des sites internationaux comme ASOS ou Zara en payant en monnaie locale. Sa startup a levé 4,5 millions de dollars avec Amex Ventures.",
    image: "https://readdy.ai/api/search-image?query=nigerian%20african%20woman%20entrepreneur%20London%20UK%20diaspora%20fintech%20cross-border%20commerce%20startup%20founder%20Cambridge%20confident%20professional%20modern%20portrait&width=600&height=400&seq=dia-new1&orientation=landscape",
    entrepreneur: "Jessica Anuna",
    country: "Nigeria → UK",
    countryFlag: "🇳🇬🇬🇧",
    category: "Diaspora Africaine",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2022/06/14/nigerian-startup-klasha-gets-an-additional-2-1m-for-its-cross-border-commerce-play/",
    date: "2022-06-14",
    views: 0,
    readTime: 6,
    keyPoints: [
      "Klasha a levé 4,5 millions de dollars avec Amex Ventures — leur premier investissement dans une startup africaine",
      "La plateforme permet aux Africains de payer des marchands internationaux en monnaie locale (naira, cedi, etc.)",
      "Jessica Anuna a étudié à Cambridge avant de retourner au Nigeria et de constater le problème du commerce transfrontalier",
      "Klasha opère au Nigeria, Ghana, Kenya et Zambie avec des plans d\'expansion en Asie",
      "La startup a été soutenue par Greycroft, Seedcamp et Global Ventures parmi d\'autres investisseurs"
    ],
    quote: "Pourquoi un Africain devrait-il avoir un accès limité au commerce mondial ? Klasha supprime cette frontière invisible.",
    quoteAuthor: "Jessica Anuna, Fondatrice de Klasha"
  },
  {
    id: "dia-1",
    title: "Iddris Sandu : Le génie ghanéen qui code pour Kanye West et Snapchat depuis Los Angeles",
    summary: "Arrivé aux États-Unis à 13 ans depuis le Ghana, Iddris Sandu est devenu l\'un des développeurs les plus influents de la Silicon Valley. Il a conçu l\'interface de Snapchat, collaboré avec Kanye West et crée aujourd\'hui des technologies pour les communautés africaines.",
    image: "https://readdy.ai/api/search-image?query=young%20african%20ghanaian%20tech%20genius%20developer%20Los%20Angeles%20Silicon%20Valley%20confident%20modern%20creative%20studio%20urban%20professional%20portrait&width=600&height=400&seq=dia1&orientation=landscape",
    entrepreneur: "Iddris Sandu",
    country: "Ghana → USA",
    countryFlag: "🇬🇭🇺🇸",
    category: "Diaspora Africaine",
    sector: "Tech",
    source: "Forbes",
    sourceUrl: "https://www.forbes.com",
    originalUrl: "https://www.forbes.com/sites/abrambrown/2021/04/02/iddris-sandu-brings-the-metaverse-to-hip-hop-by-partnering-with-jay-z/",
    date: "2026-04-06",
    views: 61200,
    readTime: 7
  },
  {
    id: "dia-5",
    title: "Ibrahima Diallo : Le Guinéen qui connecte les transferts d\'argent Afrique-Europe avec Wave",
    summary: "Co-fondateur de Wave Money, Ibrahima Diallo a quitté Conakry pour San Francisco et a créé l\'application de transfert d\'argent la moins chère du monde. Wave traite aujourd\'hui 7 milliards de dollars par an en Afrique de l\'Ouest.",
    image: "https://readdy.ai/api/search-image?query=guinean%20african%20tech%20entrepreneur%20San%20Francisco%20fintech%20money%20transfer%20startup%20diaspora%20modern%20confident%20office&width=600&height=400&seq=dia5&orientation=landscape",
    entrepreneur: "Ibrahima Diallo",
    country: "Guinée → USA",
    countryFlag: "🇬🇳🇺🇸",
    category: "Diaspora Africaine",
    sector: "Fintech",
    source: "TechCrunch",
    sourceUrl: "https://techcrunch.com",
    originalUrl: "https://techcrunch.com/2021/09/28/sequoia-heritage-stripe-and-others-invest-200m-in-african-fintech-wave-at-1-7b-valuation/",
    date: "2026-03-18",
    views: 47800,
    readTime: 9
  }
];

export const allArticles: Article[] = [
  featuredArticle,
  ...successStories,
  ...startups,
  ...innovations,
  ...femmesEntrepreneures,
  ...jeunesTalents,
  ...diasporaAfricaine
];

export const countries = [
  "Tous les pays", "Nigeria", "Kenya", "Côte d\'Ivoire", "Ghana",
  "Cameroun", "Afrique du Sud", "Guinée", "Tanzanie", "Tunisie", "Égypte", "Rwanda"
];

export const sectors = [
  "Tous les secteurs", "Fintech", "Tech", "Santé", "Éducation",
  "Mobilité", "Commerce", "Énergie", "Finance",
  "Intelligence Artificielle", "Eau & Environnement", "AgriTech"
];

export const categories = [
  "Toutes catégories", "Success Story", "Startup", "Innovation", "Femme Entrepreneuse", "Jeune Talent", "Diaspora Africaine"
];
